import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { App } from './App';
import { Home } from './pages/Home';
import { GetApp } from './pages/GetApp';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import './styles.css';

// Lazy: this page bundles the frozen 2026 archive (~120 kB of JSON). Only
// visitors who actually open the retrospective should pay for it.
const Valet2026 = lazy(() =>
  import('./pages/Valet2026').then(m => ({ default: m.Valet2026 })),
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route index element={<Home />} />
          <Route path="ladda-ner" element={<GetApp />} />
          <Route
            path="valet-2026"
            element={
              <Suspense fallback={<div className="loading">Laddar Valet 2026…</div>}>
                <Valet2026 />
              </Suspense>
            }
          />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<Terms />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
